import * as React from 'react';
export default function SvgCapricorn() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4.75s3-.093 3 2.25v6M7.75 7.5c0-1.38.75-2.75 3.25-2.75s3.25 1.37 3.25 2.75v6.889m0 0V15l1.049 1.4a2.197 2.197 0 103.392-2.786l-.076-.085a2.33 2.33 0 00-3.352-.118l-1.013.978zm0 0l-2.838 2.739a4 4 0 01-2.778 1.122H7.75",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}